import { CSSProperties, FC } from 'react'
import { GoogleMap } from '@react-google-maps/api'
import {
  Locations,
  mapType,
  OnMarkerClickType,
} from '@components/Location/location.types'
import MarkerWithInfo from '@components/Location/reusable/Map/Marker'
import mapStyles from '@components/Location/reusable/Map/mapStyles'

type PropTypes = mapType & {
  onMarkerClick?: OnMarkerClickType
  allLocations: Locations
  mapContainerStyle?: CSSProperties
}

const Map: FC<PropTypes> = ({
  state: { isLoaded, locationsOnMap, activeMarker },
  handlers: { handleOnLoad, handleActiveMarker },
  onMarkerClick,
  allLocations,
  mapContainerStyle = { width: '100%', height: '75vh' },
}) => {
  if (!isLoaded) return <h3>Loading...</h3>

  return (
    <GoogleMap
      onLoad={handleOnLoad}
      onClick={() => handleActiveMarker(null)}
      mapContainerStyle={mapContainerStyle}
      options={{ styles: mapStyles }}
    >
      {allLocations.map((location) => (
        <MarkerWithInfo
          key={location.id}
          location={location}
          handleActiveMarker={handleActiveMarker}
          activeMarker={activeMarker}
          onMarkerClick={onMarkerClick}
        />
      ))}
    </GoogleMap>
  )
}

export default Map
